<template>
    <v-card class="mx-auto" max-width="500">
        <v-card-title color="surface-variant" class="title-text">
            系統登入
        </v-card-title>
        <v-card-text>
            <v-form ref="form">
             
                
                        <v-text-field label="學生學號" maxLength="8" v-model="user.userid" :rules="[(v: string) => requireRule(v)]" @keyup.enter="() => handleEnterKey()"></v-text-field>
                
                        <v-text-field label="學生身分證號" v-model="user.password" type="password"
                            :rules="[(v: string) => requireRule(v)]" @keyup.enter="() => handleEnterKey()"></v-text-field>
                  
           
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn ID="LoginBtn" class="title-text btn submit-btn" @click="() => toLogin()" variant="outlined">登入</v-btn>
        </v-card-actions>
    </v-card>
    <v-snackbar v-model="snack">{{ msg }}</v-snackbar>
</template>
<script setup lang="ts">

import { useUser } from '@/composables/useUser';
import { ILogin } from "@/lib/interface";

import { useReCaptcha } from 'vue-recaptcha-v3';

const { isLogin } = useUser();
const { requireRule } = useRules();
const { login } = useUser();
const { errMsg } = useApi();
const form: any = ref(null);
const user = ref<ILogin>({ userid: "", password: "", gtoken: "" })
const msg = ref("");
const snack = ref(false);


/*componemts */

const recaptchaInstance = useReCaptcha();

const recaptcha = async () => {
    // optional you can await for the reCaptcha load
    await recaptchaInstance?.recaptchaLoaded();

    // get the token, a custom action could be added as argument to the method
    const token = await recaptchaInstance?.executeRecaptcha('yourActionHere');
    
        user.value.gtoken = token !== undefined ?token:"";    
    
};

/* */
const  toLogin = async() => { 
    await recaptcha();
    form.value.validate().then((res: any) => {
        if (res.valid) {
            useFetch("/api/auth/login", { method: "POST", body: { ...user.value } })
                .then((res: any) => {
                    /*
                     *console.log(res);  
                     *console.log('res.data.value:'+res.data.value); 
                     *console.log('res.error.value:'+!!res.error.value); 
                     *console.log('isLogin.value:'+isLogin.value); 
                     */        
                    if (!!res.error.value == false) {                        
                        login(res.data);
                        navigateTo({ path: "/abslea" });
                        //navigateTo({ path: "/course" });
                        
                    }
                    else {
                        snack.value = true;
                        msg.value = errMsg(res.error.value);
                    }
                })
        }
    });

}

const handleEnterKey = () => {
   
    const loginBtn = document.getElementById('LoginBtn') as HTMLElement;
    if (loginBtn) {        
        loginBtn.click();
    }

}




</script>